import ErrorLayout from "@app/layouts/ErrorLayout/ErrorLayout";
import RouteErrorElement from "@app/layouts/ErrorLayout/RouteErrorElement";
import AboutUs from "@pages/AboutUs/AboutUs";
import { fetchContext, ResponseType } from "@sphtech/web2-core/ssr";
import { RouteObject } from "react-router";

const errorElement = import.meta.env.PROD ? <RouteErrorElement /> : undefined;

/**
 * Routes specific to FEMALE
 */
export const pubRoutes: RouteObject[] = [
  {
    path: "/about-us",
    element: <AboutUs />,
    errorElement,
    loader: fetchContext,
  },
  {
    path: "latest-stories",
    element: (
      <ErrorLayout
        response={{
          type: ResponseType.CLIENT_ERROR,
          statusCode: 404,
        }}
      />
    ),
  },
];
